var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageView"},[_c('wdPcForm',{attrs:{"schemaName":_vm.schemaName,"callback":_vm.callback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }